/*
 * ame-faq-accordion.js — native replacement for Bootstrap 3's collapse plugin.
 *
 * Replaces the ONLY live consumer of Bootstrap 3.3.0 JS (the FAQ accordion in snippets/faq.liquid)
 * so the maxcdn.bootstrapcdn.com dependency can be dropped. No framework, no CDN, ~1 KB.
 *
 * It honours Bootstrap 3's exact DOM contract, because the stylesheet that hides and reveals the
 * panels is unchanged: a panel is hidden with `.collapse` and revealed by adding `.in`. That
 * contract was verified in the live page before this was written (adding `.in` -> display:block,
 * height 1767; removing it -> display:none), so no CSS change is needed and the FAQ looks identical.
 *
 * Accessibility is preserved and slightly improved: aria-expanded tracks state, aria-controls is
 * backfilled from the panel id when missing, and Space activates the trigger (Enter already works
 * natively on the anchors this markup uses).
 */
(function () {
  'use strict';

  function panelFor(trigger) {
    var sel = trigger.getAttribute('data-target') || trigger.getAttribute('href');
    if (!sel || sel.charAt(0) !== '#' || sel.length < 2) return null;
    // getElementById, not querySelector: the second FAQ group's ids start with a digit ("#1collapseOne"),
    // which is a valid id but an INVALID CSS selector — querySelector threw and those panels never opened.
    return document.getElementById(sel.slice(1));
  }

  function triggerFor(panel) {
    return document.querySelector(
      '[data-toggle="collapse"][href="#' + panel.id + '"], ' +
      '[data-toggle="collapse"][data-target="#' + panel.id + '"]');
  }

  function setState(trigger, panel, open) {
    panel.classList.toggle('in', open);
    if (trigger) {
      trigger.classList.toggle('collapsed', !open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!trigger.getAttribute('aria-controls') && panel.id) {
        trigger.setAttribute('aria-controls', panel.id);
      }
    }
  }

  function toggle(trigger) {
    var panel = panelFor(trigger);
    if (!panel) return;
    var open = !panel.classList.contains('in');

    // data-parent reproduces Bootstrap's accordion behaviour: opening one closes its siblings.
    var parentSel = trigger.getAttribute('data-parent');
    if (open && parentSel) {
      var group = null;
      try { group = document.querySelector(parentSel); } catch (e) { group = null; }
      if (group) {
        Array.prototype.forEach.call(group.querySelectorAll('.in'), function (other) {
          if (other === panel || !other.classList.contains('panel-collapse')) return;
          setState(triggerFor(other), other, false);
        });
      }
    }
    setState(trigger, panel, open);
  }

  function init() {
    var triggers = document.querySelectorAll('[data-toggle="collapse"]');
    Array.prototype.forEach.call(triggers, function (trigger) {
      var panel = panelFor(trigger);
      if (!panel || trigger.getAttribute('data-ame-collapse') === 'bound') return;
      trigger.setAttribute('data-ame-collapse', 'bound');

      if (!trigger.getAttribute('role')) trigger.setAttribute('role', 'button');
      if (trigger.tagName !== 'A' && trigger.tagName !== 'BUTTON' && !trigger.hasAttribute('tabindex')) {
        trigger.setAttribute('tabindex', '0');
      }
      setState(trigger, panel, panel.classList.contains('in'));

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        toggle(trigger);
      });
      trigger.addEventListener('keydown', function (event) {
        if (event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          toggle(trigger);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
